import { useMemo } from 'react'
import momentColumnLabels from '../../helpers/measurementSignals/momentColumnLabels'

/**
 * De kolommen van een meetmoment-matrix: vaste kolommen ervoor, één kolom per
 * meetmoment, vaste kolommen erachter.
 *
 * Gedeeld door 'Aankomende meetmomenten' en 'Anonieme onderzoeken'. Die twee
 * kaarten tonen iets heel anders in de cel — een invulstatus tegenover een
 * aantal — maar de kolomopbouw is letterlijk dezelfde, en dat is precies het
 * soort recept dat binnen een maand uit elkaar loopt.
 * AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
 *
 * Eén kolom staat voor één POSITIE in het onderzoek, niet voor één meetmoment:
 * de rijen komen uit verschillende onderzoeken en die hebben niet dezelfde
 * meetmomenten. Zie `momentColumnLabels`.
 *
 * @param {object} args
 * @param {Array<{moments?: Array<{Title?: string}>}>} args.items - De rijen, al gesorteerd
 * @param {Array<object>} args.leading - Kolomdefinities vóór de meetmomenten (moduleconstante)
 * @param {Array<object>} args.trailing - Kolomdefinities erachter (moduleconstante)
 * @returns {{momentLabels: Array<string>, columns: Array<object>}}
 */
const useMomentMatrixColumns = ({ items, leading, trailing }) => {
    // Het aantal kolommen volgt uit de rijen die er staan: de onderzoeken in
    // de lijst hebben niet allemaal evenveel meetmomenten.
    const momentLabels = useMemo(() => momentColumnLabels(items), [items])

    const columns = useMemo(() => [
        ...leading,
        ...momentLabels.map((label, index) => ({
            key: `moment-${index}`,
            label: label.toUpperCase(),
            searchable: false,
            headerClassName: 'moment-matrix-head',
        })),
        ...trailing,
    ], [leading, momentLabels, trailing])

    return { momentLabels, columns }
}

export default useMomentMatrixColumns
